"use strict";

exports.__esModule = true;
exports.DashboardCollectionContext = void 0;
exports.DashboardCollectionController = DashboardCollectionController;
var _react = _interopRequireDefault(require("react"));
var _API = require("../../API");
var _useAiDraftsStore = require("../../AI/Authoring/useAiDraftsStore");
var _excluded = ["children", "sortConfig"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DashboardCollectionContext = exports.DashboardCollectionContext = /*#__PURE__*/_react["default"].createContext({});

/**
 * Provides access to dashboards via a render prop.
 */
function DashboardCollectionController(_ref) {
  var children = _ref.children,
    _ref$sortConfig = _ref.sortConfig,
    sortConfig = _ref$sortConfig === void 0 ? {
      order: "asc",
      prop: "name"
    } : _ref$sortConfig,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  // AI-made dashboards live in the browser until the backend takes them.
  var localStore = (0, _useAiDraftsStore.useAiDraftsStore)("dashboards");
  return /*#__PURE__*/_react["default"].createElement(_API.Collection, _extends({
    baseURL: "/api/v3/ui-config/dashboards",
    itemBaseURL: "/api/v3/ui-config/dashboards/:id",
    sortConfig: sortConfig,
    localStore: localStore
  }, extra), function (collection) {
    return /*#__PURE__*/_react["default"].createElement(DashboardCollectionContext.Provider, {
      value: collection
    }, children);
  });
}